import { Product } from '../types';

export const SolutionsKm: Product[] = [
   {
      id: 1,
      slug: 'sales',
      name: 'ដំណោះស្រាយការលក់',
      shortName: 'ការលក់',
      tagline: 'ពីអតិថិជនសក្តានុពល ដល់សម្រង់តម្លៃ ការគិតលុយ និងការទទួលប្រាក់ ក្នុងខ្សែតែមួយ',
      docsUrl: 'https://docs.akas.co/en/crm/',
      description:
         'លក់បានគ្រប់កន្លែង ជាមួយ ការលក់តាមបញ្ជរ(POS) ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជនដែលតភ្ជាប់គ្នា។ បង្កើតសម្រង់តម្លៃ បម្លែងទៅជាវិក្កយបត្រ និងតាមដានចំណូលពីអតិថិជនសក្តានុពលដល់ការទូទាត់ ជាមួយ AKAS។',
      images: [],
      backgroundImage: '/images/backgrounds/crm.jpeg',
      mainFeatures: [
         {
            icon: '🧾',
            title: 'សម្រង់តម្លៃ និងវិក្កយបត្រ',
            description:
               'បង្កើតសម្រង់តម្លៃលម្អិតជាទំនិញ ជាមួយពន្ធ ការបញ្ចុះតម្លៃ និងលក្ខខណ្ឌទូទាត់។ បម្លែងទៅជាវិក្កយបត្រដោយចុចតែម្តង ហើយទទួលប្រាក់បានលឿនជាងមុន។',
            images: [],
         },
         {
            icon: '🛒',
            title: 'ការលក់តាមបញ្ជរ',
            description:
               'បង្កើនល្បឿនការគិតលុយ ជាមួយការស្កេនបាកូដ បង្កាន់ដៃបោះពុម្ព ឬផ្ញើអ៊ីមែល រក្សាទុក និងបន្តកន្ត្រកទំនិញ ការផ្គូផ្គងលុយក្នុងថត និងដំណើរការបានទាំងពេលអ៊ីនធឺណិតដាច់។',
            images: [],
         },
         {
            icon: '🏪',
            title: 'ហាងអនឡាញ និងកាតាឡុក',
            description:
               'បោះពុម្ពផ្សាយកាតាឡុកផលិតផល ជាមួយកម្រិតតម្លៃ គ្រប់គ្រងភាពមានស្តុក និងធ្វើសមកាលកម្មការបញ្ជាទិញពីវេបសាយ ទីផ្សារអនឡាញ និងបណ្តាញហាង។',
            images: [],
         },
         {
            icon: '🔄',
            title: 'ដំណើរការលក់ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
            description:
               'ទទួលអតិថិជនសក្តានុពលពីទម្រង់វេបសាយ តាមដានឱកាសលក់ កំណត់ពេលតាមដានឡើងវិញ និងបញ្ជូនដោយស្វ័យប្រវត្តិទៅផ្នែកវិក្កយបត្រ និងការប្រគល់ទំនិញ។',
            images: [],
         },
         {
            icon: '📦',
            title: 'ស្តុក និងការប្រគល់ទំនិញ',
            description:
               'តាមដានស្តុកតាមទីតាំង កក់ស្តុកសម្រាប់ការបញ្ជាទិញដែលបានអនុម័ត ហើយគ្រប់គ្រងការជ្រើសរើស ការវេចខ្ចប់ និងការធ្វើបច្ចុប្បន្នភាពការដឹកជញ្ជូនក្នុងកន្លែងតែមួយ។',
            images: [],
         },
         {
            icon: '📈',
            title: 'របាយការណ៍លក់',
            description:
               'តាមដានចំណូល រឹមប្រាក់ចំណេញ ពន្ធ និងលទ្ធផលតាមឆានែល ជាមួយ dashboard ដែលឆ្លុះបញ្ចាំង KPI ក្នុងរបាយការណ៍លក់របស់ AKAS។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយលក់ — សម្រង់តម្លៃ, ការលក់តាមបញ្ជរ, ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
         description:
            'ដំណើរការសម្រង់តម្លៃ វិក្កយបត្រ ការលក់តាមបញ្ជរ ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជនក្នុងវេទិកាលក់របស់ AKAS តែមួយ។ លក់នៅហាង និងអនឡាញ ជាមួយទំនិញ ស្តុក និងរបាយការណ៍កណ្តាល។',
         keywords:
            'ដំណោះស្រាយលក់, ការលក់តាមបញ្ជរ, ហាងអនឡាញ, ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន, CRM, សម្រង់តម្លៃ, វិក្កយបត្រ, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✓',
            title: 'លំហូរការងារអនុម័ត',
            description:
               'បញ្ជូនការបញ្ចុះតម្លៃ កំណត់សម្គាល់ឥណទាន និងកិច្ចសន្យាធំៗ ទៅអនុម័តមុននឹងចុះបញ្ជី។',
         },
         {
            icon: '🌐',
            title: 'ពហុភាសា និងពហុរូបិយប័ណ្ណ',
            description:
               'អង់គ្លេស និងខ្មែរមានរួចហើយ ជាមួយភាសាបន្ថែម តម្លៃពហុរូបិយប័ណ្ណ និងច្បាប់ពន្ធ។',
         },
         {
            icon: '⚡',
            title: 'ការលក់តាមបញ្ជរ ដែលធ្វើការបានពេលគ្មានអ៊ីនធឺណិត',
            description:
               'បន្តលក់ពេលអ៊ីនធឺណិតដាច់ ហើយធ្វើសមកាលកម្មពេលតភ្ជាប់ឡើងវិញ។',
         },
         {
            icon: '🔌',
            title: 'ការតភ្ជាប់',
            description:
               'តភ្ជាប់ច្រកទូទាត់ ម៉ាស៊ីនស្កេនបាកូដ ម៉ាស៊ីនបោះពុម្ព និងកម្មវិធីបន្ថែមរបស់ AKAS។',
         },
         {
            icon: '🔔',
            title: 'ការជូនដំណឹង',
            description:
               'ជូនដំណឹងដល់ក្រុមលក់ ហិរញ្ញវត្ថុ និងប្រតិបត្តិការ នៅពេលមានព្រឹត្តិការណ៍សំខាន់លើការបញ្ជាទិញ និងការទូទាត់។',
         },
         {
            icon: '📝',
            title: 'កំណត់ហេតុសវនកម្ម',
            description:
               'តាមដានសកម្មភាពអ្នកប្រើប្រាស់លើសម្រង់តម្លៃ វិក្កយបត្រ និងវេនការលក់តាមបញ្ជរ។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'ពីសម្រង់តម្លៃដល់ប្រាក់ លឿនជាងមុន',
            description:
               'បម្លែងអតិថិជនសក្តានុពលទៅវិក្កយបត្រយ៉ាងឆាប់រហ័ស ជាមួយការអនុម័តណែនាំ និងការបញ្ជូនស្វ័យប្រវត្តិ។',
         },
         {
            number: '02',
            title: 'ការគ្រប់គ្រងគ្រប់ឆានែលលក់',
            description:
               'រក្សា ការលក់តាមបញ្ជរ ហាងអនឡាញ និងការបញ្ជាទិញ B2B ឱ្យស៊ីសង្វាក់គ្នា ជាមួយប្រភពទំនិញ និងស្តុកតែមួយ។',
         },
         {
            number: '03',
            title: 'កាត់បន្ថយកំហុស',
            description:
               'ធ្វើឱ្យតម្លៃ ពន្ធ និងការកក់ស្តុកមានស្តង់ដារ ដើម្បីកាត់បន្ថយការធ្វើឡើងវិញ និងការបាត់បង់។',
         },
         {
            number: '04',
            title: 'បទពិសោធន៍អតិថិជនប្រសើរ',
            description:
               'ផ្តល់ឱ្យអ្នកទិញនូវតម្លៃស្មើគ្នា ការគិតលុយលឿន និងព័ត៌មានធ្វើបច្ចុប្បន្នភាពការបញ្ជាទិញច្បាស់លាស់។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ពីអតិថិជនសក្តានុពលដល់ប្រាក់',
         path: 'Lead → Customer → Quote → Sales order → Invoice → Receipt / ការលក់តាមបញ្ជរ / Store',
         steps: [
            {
               title: 'ឈ្នះកិច្ចសន្យា',
               description: 'ទទួលអតិថិជនសក្តានុពល បម្លែងទៅជាអតិថិជន គ្រប់គ្រង pipeline ហើយផ្ញើសម្រង់តម្លៃដែលបានអនុម័ត។',
            },
            {
               title: 'អនុម័ត និងចេញវិក្កយបត្រ',
               description: 'បម្លែងសម្រង់តម្លៃទៅជាបញ្ជាលក់ បន្ទាប់មកវិក្កយបត្រជាមួយទំនិញ ពន្ធ និងលក្ខខណ្ឌដូចគ្នា។',
            },
            {
               title: 'លក់នៅហាង ឬអនឡាញ',
               description: 'ការលក់តាមបញ្ជរ សម្រាប់ហាង និងភោជនីយដ្ឋាន ព្រមទាំងហាងអនឡាញ ប្រើកាតាឡុក និងស្តុកដូចគ្នា។',
            },
            {
               title: 'ទទួលប្រាក់ និងរបាយការណ៍',
               description: 'បង្កាន់ដៃ KHQR ប្រាក់កក់ និងគណនីត្រូវទទួល (AR) ស្ថិតក្នុងការគ្រប់គ្រងចំណូល ហើយអាចចុះបញ្ជីគណនេយ្យ។',
            },
         ],
      },
      highlights: [
         'សម្រង់តម្លៃបម្លែងទៅជាបញ្ជាលក់ និងវិក្កយបត្រ',
         'ការលក់តាមបញ្ជរ ហាង និងភោជនីយដ្ឋានលើកាតាឡុកដូចគ្នា',
         'ហាងអនឡាញ, pipeline ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន និងរបាយការណ៍ចំណូល',
      ],
      related: [
         { label: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន', to: '/products/crm' },
         { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
         { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
         { label: 'ហាងអនឡាញ', to: '/products/online-store' },
      ],
   },
   {
      id: 2,
      slug: 'inventory',
      name: 'ដំណោះស្រាយស្តុក',
      shortName: 'ស្តុក',
      tagline: 'បញ្ជាទិញ ទទួល ផ្ទេរ និងតុល្យភាពស្តុកគ្រប់ទីតាំង',
      docsUrl: 'https://docs.akas.co/en/inventory/',
      description:
         'គ្រប់គ្រងស្តុកគ្រប់ឃ្លាំង រក្សាបរិមាណឱ្យត្រឹមត្រូវ ហើយបំពេញស្តុកទាន់ពេល ជាមួយស្តុក AKAS។',
      images: [],
      backgroundImage: '/images/solutions/inventory-solution.jpg',
      mainFeatures: [
         {
            icon: '📦',
            title: 'ស្តុកពហុទីតាំង',
            description:
               'តាមដានស្តុកក្នុងដៃ ស្តុកដែលបានកក់ និងស្តុកដែលអាចសន្យាបាន តាមឃ្លាំង ហាង ឬធ្នើរ។',
            images: [],
         },
         {
            icon: '🔄',
            title: 'ចលនាស្តុក',
            description:
               'ទទួល ផ្ទេរ និងកែតម្រូវស្តុក ជាមួយដានអនុម័ត និងកំណត់សម្គាល់ភាពខុសគ្នា។',
            images: [],
         },
         {
            icon: '🧾',
            title: 'ការទិញ និងការបំពេញស្តុក',
            description:
               'បង្កើតបញ្ជាទិញពីចំណុចបញ្ជាទិញឡើងវិញ និងរយៈពេលដឹកជញ្ជូន។ ផ្គូផ្គងការទទួលទៅវិក្កយបត្រអ្នកផ្គត់ផ្គង់។',
            images: [],
         },
         {
            icon: '🚚',
            title: 'ការប្រគល់ទំនិញ',
            description:
               'ជ្រើសរើស វេចខ្ចប់ និងផ្ញើតាមបញ្ជាលក់ ជាមួយព័ត៌មានធ្វើបច្ចុប្បន្នភាពទៅផ្នែកលក់ និងហិរញ្ញវត្ថុ។',
            images: [],
         },
         {
            icon: '🏷️',
            title: 'តាមដាន lot / serial',
            description:
               'កត់ត្រាលេខ batch/serial និងថ្ងៃផុតកំណត់ សម្រាប់ការតាមដាន និងការហៅទំនិញត្រឡប់។',
            images: [],
         },
         {
            icon: '📈',
            title: 'ការវិភាគស្តុក',
            description:
               'តាមដានការចរាចរ អាយុស្តុក តម្លៃស្តុក និងការបាត់បង់ ជាមួយ dashboard តម្រឹមរបាយការណ៍ AKAS។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយស្តុក — ស្តុក ការទិញ និងឃ្លាំង',
         description:
            'គ្រប់គ្រងស្តុកគ្រប់ឃ្លាំង រក្សាបរិមាណឱ្យត្រឹមត្រូវ ហើយបំពេញស្តុកទាន់ពេល ជាមួយស្តុក AKAS។',
         keywords:
            'ដំណោះស្រាយស្តុក, ការគ្រប់គ្រងស្តុក, ឃ្លាំង, ការបំពេញស្តុក, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✅',
            title: 'រាប់ស្តុកជាប្រចាំ និងត្រួតពិនិត្យ',
            description:
               'រាប់ស្តុកតាមកាលកំណត់ និងផ្គូផ្គងភាពខុសគ្នាជាមួយការអនុម័ត។',
         },
         {
            icon: '📡',
            title: 'បាកូដ និងម៉ាស៊ីនស្កេន',
            description:
               'បង្កើនល្បឿនការទទួល និងការជ្រើសរើស ជាមួយលំហូរការងារងាយស្រួលបាកូដ។',
         },
         {
            icon: '🔔',
            title: 'ការជូនដំណឹង',
            description:
               'ជូនដំណឹងពេលស្តុកតិច ការបញ្ជាទិញរង់ចាំ និងការទទួលយឺតពេល។',
         },
         {
            icon: '🔌',
            title: 'ការតភ្ជាប់',
            description:
               'តភ្ជាប់ ការលក់តាមបញ្ជរ ហាងអនឡាញ ការទិញ និងម៉ូឌុលគណនេយ្យ។',
         },
         {
            icon: '📝',
            title: 'កំណត់ហេតុសវនកម្ម',
            description: 'កត់ត្រាថានរណាកែស្តុក ពេលណា ហើយហេតុអ្វី។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'ភាពត្រឹមត្រូវស្តុក',
            description:
               'កាត់បន្ថយស្តុកអស់ និងស្តុកលើស ជាមួយការមើលឃើញពហុទីតាំងពេលជាក់ស្តែង។',
         },
         {
            number: '02',
            title: 'ការប្រគល់ទំនិញលឿន',
            description:
               'ជ្រើសរើស វេចខ្ចប់ និងផ្ញើលឿនជាងមុន ជាមួយលំហូរការងារណែនាំដែលភ្ជាប់ទៅបញ្ជាលក់។',
         },
         {
            number: '03',
            title: 'ចំណាយជាប់ស្តុកតិចជាងមុន',
            description:
               'បំពេញស្តុកតាមតម្រូវការ និងរយៈពេលដឹកជញ្ជូន ដើម្បីកាត់ស្តុកលើស។',
         },
         {
            number: '04',
            title: 'ការអនុលោម និងតាមដាន',
            description:
               'ការគ្រប់គ្រង lot/serial និងដានអនុម័ត ធ្វើឱ្យការហៅទំនិញត្រឡប់ និងការត្រួតពិនិត្យងាយស្រួល។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ទិញ រក្សាទុក លក់',
         path: 'Purchase order → Receive → Transfer / adjust / withdraw → Invoice deducts stock',
         steps: [
            {
               title: 'បញ្ជាទិញ និងទទួល',
               description: 'បង្កើតបញ្ជាទិញទៅអ្នកផ្គត់ផ្គង់ បន្ទាប់មកទទួលទំនិញចូលទីតាំងមួយ។',
            },
            {
               title: 'ផ្ទេរស្តុក',
               description: 'ផ្ទេររវាងឃ្លាំង កែតម្រូវបន្ទាប់ពីរាប់ ឬប្រគល់សម្រាប់ការដកស្តុកដោយខ្លួនឯង។',
            },
            {
               title: 'លក់',
               description: 'ការចេញវិក្កយបត្រទំនិញស្តុកក្នុងការគ្រប់គ្រងចំណូល កាត់បរិមាណស្តុកក្នុងដៃ។',
            },
            {
               title: 'ពិនិត្យ',
               description: 'តុល្យភាព និងរបាយការណ៍ស្តុក បង្ហាញអ្វីដែលនៅលើធ្នើរ។',
            },
         ],
      },
      highlights: [
         'បញ្ជាទិញ និងទំនិញដែលបានទទួល',
         'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុកដោយខ្លួនឯង',
         'តុល្យភាពធ្វើបច្ចុប្បន្នភាពពេលទំនិញស្តុកត្រូវចេញវិក្កយបត្រ',
      ],
      related: [
         { label: 'ម៉ូឌុលស្តុក', to: '/products/inventory' },
         { label: 'ចំណាយ', to: '/products/expenses' },
         { label: 'មគ្គុទ្ទេសក៍ស្តុក', href: 'https://docs.akas.co/en/inventory/' },
      ],
   },
];
